import type { Actor, AccessPageContext } from '../../common/types';
import { isUser, hasPermissionsGate } from '../../common/utils';
import { MAX_RESULTS_PER_PAGE, RESULTS_PER_BATCH } from './constants';
import type { I18nFlagMsgKey } from './types';

export const isPageInNextBucket = (
	pageToCheck: number,
	currentBucket: number,
	numberOfVisiblePages: number,
): boolean => pageToCheck > currentBucket * numberOfVisiblePages;

export const isPageInPreviousBucket = (
	pageToCheck: number,
	currentBucket: number,
	numberOfVisiblePages: number,
): boolean => pageToCheck <= (currentBucket - 1) * numberOfVisiblePages;

export const getPageNumberForBatchStart = (
	batchNumber: number,
	numberOfVisiblePages: number,
): number => (batchNumber - 1) * numberOfVisiblePages + 1;

export const getRemoveActorSuccessMsgKey = (
	removedParty: Actor,
	context: AccessPageContext,
): I18nFlagMsgKey => {
	const userKey = hasPermissionsGate(context)
		? 'removedUserSuccessMsgPermissionGated'
		: 'removedUserSuccessMsg';
	const groupKey = hasPermissionsGate(context)
		? 'removedGroupSuccessMsgPermissionGated'
		: 'removedGroupSuccessMsg';

	return isUser(removedParty.type) ? userKey : groupKey;
};

export const getStartIndex = (currentPage: number, pageNumber: number, pageSize: number): number =>
	(currentPage - 1) * MAX_RESULTS_PER_PAGE - (pageNumber - 1) * pageSize;

export const getNumberOfPages = (
	pageNumber: number,
	totalActors: number,
	isActorsFetching: boolean,
): number =>
	(pageNumber - 1) * Math.ceil(RESULTS_PER_BATCH / MAX_RESULTS_PER_PAGE) +
	Math.ceil((isActorsFetching ? RESULTS_PER_BATCH : totalActors) / MAX_RESULTS_PER_PAGE);
